import {
  AbTestingFeature,
  abTestingFeatures,
} from '@wwe-portal/entities/ab-testing.type';
import { FeatureFlagEnum, Flag } from '@wwe-portal/entities/global.type';

export const experimentFlags: Partial<Record<Flag, AbTestingFeature>> = {
  [FeatureFlagEnum['overhaul.leftSidebar']]:
    abTestingFeatures.SGSPT_ABTesting_Overhaul,
};
